import { useCrossdockModal } from "crossdock/common/modal";

export function useUnexpectedSkuModal() {
  const { hideAllModals } = useCrossdockModal();
  return { onContinueClick: hideAllModals };
}
